"use strict";
require('../company/CompanyService.js');

TextCarouselDirective.$inject = [];
function TextCarouselDirective() {
  return {
    restrict : 'AE',
    replace: true,
    link: function(scope, elm) {
      scope.$on('ngRepeatCompleted', function(){
        var counter = 0;
        var items = angular.element(elm).find('p');
        var amount = items.length;
        var current = items[0];      

        function navigate(direction) {
          angular.element(current).removeClass('current');
          counter = counter + direction;
          if (direction === -1 && 
              counter < 0) { 
            counter = amount - 1; 
          }
          if (direction === 1 && 
              !items[counter]) { 
            counter = 0;
          }
          current = items[counter];
          angular.element(current).addClass('current');
        }
        navigate(0);
        setInterval(function(){
          navigate(1);
        }, 8000);
      });
    }
  };
}

ngRepeatCompletedDirective.$inject = [];
function ngRepeatCompletedDirective() {
  return {
    restrict: 'AE',
    link: function(scope) {
      scope.$watch('$last', function(newData){
        if (newData) {
          scope.$emit('ngRepeatCompleted');
        }
      });
    }
  };
}

angular.module('dokiv')
  .directive('textCarousel', TextCarouselDirective)
  .directive('ngRepeatCompleted', ngRepeatCompletedDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/TextCarouselDirective.js
// module id = 251
// module chunks = 0